package ir.yusefpasha.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.components.SocialBar
import ir.yusefpasha.models.Section
import ir.yusefpasha.models.Theme
import ir.yusefpasha.style.NavigationItemStyle
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun FooterSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .backgroundColor(Theme.LighterGray.rgb)
            .maxWidth(Constants.SECTION_WIDTH.px)
            .fillMaxWidth()
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        FooterContent(breakpoint)
    }
}

@Composable
private fun FooterContent(breakpoint: Breakpoint) {
    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent
                else 90.percent
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            modifier = Modifier.width(150.px).margin(bottom = 40.px),
            src = Res.Image.LOGO,
            desc = "Logo Image"
        )
        FooterMenu(breakpoint)
        SocialBar(isRow = true)
    }
}

@Composable
private fun FooterMenu(breakpoint: Breakpoint) {

    if (breakpoint > Breakpoint.SM) {
        Row(
            modifier = Modifier.margin(bottom = 20.px),
            horizontalArrangement = Arrangement.Center
        ) {
            Section.values().forEach { section ->
                Link(
                    modifier = NavigationItemStyle.toModifier()
                        .fontFamily(Constants.FONT_FAMILY)
                        .padding(right = 25.px)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Normal)
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path,
                    text = section.title
                )
            }
        }
    } else
        Column(
            modifier = Modifier.margin(bottom = 10.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Section.values().forEach { section ->
                Link(
                    modifier = NavigationItemStyle.toModifier()
                        .fontFamily(Constants.FONT_FAMILY)
                        .padding(bottom = 15.px)
                        .fontSize(14.px)
                        .fontWeight(FontWeight.Normal)
                        .textDecorationLine(TextDecorationLine.None),
                    path = section.path,
                    text = section.title
                )
            }
        }
}